import React from 'react';
import Modal from 'react-responsive-modal';
import { useState, useRef } from 'react';
import AudioAnalyser from "react-audio-analyser";
import { BiPlayCircle, BiPauseCircle } from "react-icons/bi";
import { AiFillSave } from "react-icons/ai";
import { validFirstChercterAlsoNuber } from '../../ValidationCheck';
import { useDispatch } from 'react-redux';
import { setPopup } from '../../../redux/messageSlice';

const VoiceMessageCon = ({ onClose, isOpen }) => {

    // const closeIcon = <MdClose className="text-2xl mt-1.5 text-teal-600  dark:text-white" />;
    const closeIcon = <div className="privateCloseIcon mt-1 text-teal-600  dark:text-white" />;
    const dispatch = useDispatch()
    const [RecordingState, setRecordingState] = useState("inactive");
    const [RecordingSrc, setRecordingSrc] = useState("");
    const [RecordingFile, setRecordingFile] = useState("");
    const [RecordingGraph, setRecordingGraph] = useState(false);
    const [RecordingError, setRecordingError] = useState(false);
    const [recordedBlob, setRecordedBlob] = useState(null);
    const [RecordingStart, setRecordingStart] = useState(true);
    const [RecordingStop, setRecordingStop] = useState(false);
    const [RecordingDel, setRecordingDel] = useState(false);
    const [title, setTitle] = useState('');

    const mediaRecorderRef = useRef(null);

    const delAudio = (type) => {
        setRecordingDel(false);
        setRecordingSrc("");
        setRecordingFile("");
        if (type === "close") {
            const e = document.querySelector(".audiograph audio");
            if (e && e.parentElement) {
                e.parentElement.removeChild(e);
            }
        }
    };

    console.log(RecordingDel);

    const controlAudio = async (state) => {
        if (state === "recording") {
            setRecordingStart(false);
            setRecordingStop(true);
            setRecordingGraph(true);
            delAudio('open');

            if (RecordingState !== "recording") {
                setRecordingState("recording");
            }
        } else if (state === "paused") {
            setRecordingStart(true);
            setRecordingStop(true);
            setRecordingGraph(true);
            setRecordingDel(true);
            setRecordingState("paused");
            
        } else if (state === "inactive") {
            setRecordingStart(true);
            setRecordingStop(false);
            setRecordingDel(true);

            setRecordingState("inactive");
        }

        if (state !== "recording") {
            delAudio();
        }
    };

    const resetState = () => {
        setRecordingState("inactive");
        setRecordingSrc("");
        setRecordingFile("");
        setRecordedBlob(null);
        setRecordingGraph(false);
        setRecordingError(false);
        setRecordingStart(false);
        // setRecordingPause(false);
        setRecordingStop(false);
        setRecordingDel(false);
        setTitle("");

        // Stop media tracks if still active
        if (mediaRecorderRef.current?.stream) {
            mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
            mediaRecorderRef.current = null;
        }

        // Remove audio element from DOM
        const audioEl = document.querySelector(".audiograph audio");
        if (audioEl?.parentElement) {
            audioEl.parentElement.removeChild(audioEl);
        }
    };

    const audioProps = {
        audioSrc: RecordingSrc,
        audioType: 'audio/mp3',
        className: 'audiograph',
        status: RecordingState,
        backgroundColor: '#ffffff',
        strokeColor: '#0c1e47',
        timeslice: 1000,
        startCallback: (e) => {
            mediaRecorderRef.current = e.target;
        },
        pauseCallback: () => { },
        stopCallback: (blob) => {
            const blobURL = window.URL.createObjectURL(blob);
            setRecordedBlob(blob);
            setRecordingSrc(blobURL);
            setRecordingFile(`voice-message-${Date.now()}.mp3`);
            if (mediaRecorderRef.current?.stream) {
                mediaRecorderRef.current.stream.getTracks().forEach((track) => track.stop());
                mediaRecorderRef.current = null;
            }
        },
        onRecordCallback: () => { },
        errorCallback: (err) => {
            console.error("Microphone error:", err);
            setRecordingError(true);
            setRecordingStart(false);
            // setRecordingPause(false);
            setRecordingStop(false);
            setRecordingGraph(false);
            setRecordingDel(false);
        }
    };

    const continueToUpload = () => {
        if (!recordedBlob || !RecordingFile) return;

        const file = new File([recordedBlob], RecordingFile, {
            type: 'audio/mp3',
            lastModified: Date.now()
        });

        file['file_category'] = 'voice';
        file['voice_set_type'] = 'voice';
        file['voice_set_title'] = title;

        var dt = new DataTransfer();
        dt.items.add(file);
        var files = dt.files;
        dispatch(setPopup({ key: 'voice_file', value: files }))
        // dispatch(setPopup({ key: 'voice_record', data: false }))();
        onClose();
        dispatch(setPopup({ key: 'upload_popup', value: true }))
    };

    const handleInputChange = (e) => {
        const { value } = e.target;

        if (value === '') {
            setTitle(value);
            return;
        }

        if (validFirstChercterAlsoNuber(value)) {
            console.warn('Invalid input: First character cannot be special');
            return;
        }

        const trimmedValue = value.trimStart();
        if (!trimmedValue) {
            console.warn('Title cannot be only spaces');
            return;
        }

        if (/[^\w\s][^\w\s]/.test(trimmedValue)) {
            console.warn('Consecutive special characters not allowed');
            return;
        }

        setTitle(trimmedValue);
    };

    const handleClose = () => {
        resetState();
        onClose();
    };

    return (
        <Modal
            open={isOpen}
            onClose={handleClose}
            container={document.getElementById('root')}
            center
            closeIcon={closeIcon}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModal bgSurfaceDarkMainBox dark:border dark:border-[#d6d6d635]',
            }}
        >
            <div className="flex items-center justify-center">
                <div className="">
                    <h2 className="text-lg pb-4 font-semibold text-teal-800 dark:text-white">Record a voice message</h2>
                    <div className="fileUploadModalBody">
                        <div className={`voice-graph ${RecordingGraph ? 'show' : 'hide'} ${RecordingFile ? 'hidegraph' : 'showgraph'}`}>
                            {RecordingFile &&
                                <div className="voiceTitleBody mt-5">
                                    <input type="text" onChange={handleInputChange} className="customTitleInput bgSurfaceDark  dark:text-white dark:border-none" placeholder="Enter a title to this voice message" />
                                </div>}
                            <AudioAnalyser width={300} {...audioProps} />
                            {RecordingFile &&
                                <p className="text-grey-600 text-sm pt-2 pb-10 dark:text-white">File: voice-message-1745218321855.mp3</p>
                            }
                        </div>

                        <div className="flex gap-10 pb-10 pt-4 justify-center">
                            {RecordingStart ?
                                <div className="flex justify-center items-center flex-col" onClick={() => controlAudio("recording")}>
                                    <BiPlayCircle className="text-4xl text-teal-600 dark:text-white" />
                                    <p className="text-grey-600 dark:text-white">Record</p>
                                </div> :
                                <div className="flex justify-center items-center flex-col" onClick={() => controlAudio("paused")}>
                                    <BiPauseCircle className="text-4xl text-teal-600 dark:text-white" />
                                    <p className="text-grey-600 dark:text-white">Pause</p>
                                </div>
                            }
                            {RecordingStop &&
                                <div className="flex justify-center items-center flex-col" onClick={() => controlAudio("inactive")}>
                                    <AiFillSave className="text-4xl text-teal-600 dark:text-white" />
                                    <p className="text-grey-600 dark:text-white">Save</p>
                                </div>}
                            {RecordingFile &&
                                <div className="flex justify-center items-center flex-col" onClick={() => delAudio('close')}>
                                    {/* <AiFillDelete className="text-4xl text-text-body" /> */}
                                    <div className="voiceDelete_Icons " />
                                    <p className="text-text-body">Delete</p>
                                </div>}
                        </div>

                        {RecordingError &&
                            <div>
                                <p className="text-sm text-text-body text-center pb-10">To record voice messages, this demo needs access to your microphone.</p>
                            </div>}
                    </div>
                    <div className="flex justify-end gap-2.5">
                        <button onClick={handleClose} className="px-4 py-2 text-sm border border-teal-200 text-teal-600 rounded-md dark:text-white dark:border dark:border-white">
                            Cancel
                        </button>
                        <button
                            onClick={continueToUpload}
                            disabled={RecordingState !== "inactive" || !recordedBlob || !RecordingFile}
                            className={`px-4 py-2 text-sm rounded-md ${RecordingState !== "inactive" || !recordedBlob || !RecordingFile
                                ? "bg-teal-600 opacity-50 text-white pointer-events-none"
                                : "bg-teal-600 text-white"
                                }`}
                        >
                            Continue
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default VoiceMessageCon;